import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface GlobalErrorData {
  response?: {
    status?: number;
    message?: string;
  };
  [key: string]: unknown;
}

export const useUIStore = defineStore('ui', () => {
  // State
  const loading = ref(false);
  const i18nLocale = ref('');
  const loginIsOpen = ref(false);
  const loginRedirect = ref('');
  const allowClosePopup = ref(false);
  const registerIsOpen = ref(false);
  const globalInfoIsOpen = ref(false);
  const globalErrorIsOpen = ref(false);
  const globalErrorData = ref<GlobalErrorData>({});
  const globalErrorRedirectUrl = ref<string | null>(null);
  const globalErrorOnlyPopup = ref<boolean | null>(null);
  const globalErrorCode = ref<string | number | null>(null);

  // Actions
  const setLoading = (value: boolean) => {
    loading.value = value;
  };

  const setLocale = (locale: string) => {
    i18nLocale.value = locale;
  };

  // Login Modal
  const openLogin = (options?: { goToUrl?: string; allowClose?: boolean }) => {
    loginIsOpen.value = true;
    loginRedirect.value = options?.goToUrl ?? '';
    allowClosePopup.value = options?.allowClose ?? false;
  };

  const closeLogin = () => {
    loginIsOpen.value = false;
  };

  const setLoginRedirect = (target: string | null) => {
    loginRedirect.value = target ?? '';
  };

  // Register Modal
  const openRegister = (options?: { allowClose?: boolean }) => {
    registerIsOpen.value = true;
    allowClosePopup.value = options?.allowClose ?? false;
  };

  const closeRegister = () => {
    registerIsOpen.value = false;
  };

  // Global Info
  const openGlobalInfo = () => {
    globalInfoIsOpen.value = true;
  };

  const closeGlobalInfo = () => {
    globalInfoIsOpen.value = false;
  };

  // Global Error
  const openGlobalError = () => {
    globalErrorIsOpen.value = true;
  };

  const closeGlobalError = () => {
    globalErrorIsOpen.value = false;
  };

  const setGlobalErrorData = (data: GlobalErrorData) => {
    globalErrorData.value = data;
  };

  const setGlobalErrorRedirectUrl = (url: string | null) => {
    globalErrorRedirectUrl.value = url;
  };

  const setGlobalErrorCode = (code: string | number | null) => {
    globalErrorCode.value = code;
  };

  const showGlobalError = (message: string | null) => {
    if (!message) return;
    setGlobalErrorData({ response: { status: -1, message } });
    openGlobalError();
  };

  return {
    // State
    loading,
    i18nLocale,
    loginIsOpen,
    loginRedirect,
    allowClosePopup,
    registerIsOpen,
    globalInfoIsOpen,
    globalErrorIsOpen,
    globalErrorData,
    globalErrorRedirectUrl,
    globalErrorOnlyPopup,
    globalErrorCode,
    
    // Actions
    setLoading,
    setLocale,
    openLogin,
    closeLogin,
    setLoginRedirect,
    openRegister,
    closeRegister,
    openGlobalInfo,
    closeGlobalInfo,
    openGlobalError,
    closeGlobalError,
    setGlobalErrorData,
    setGlobalErrorRedirectUrl,
    setGlobalErrorCode,
    showGlobalError,
  };
});
